import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const EventSeenStatus = ({
  event,
  onSetSeen,
  isSettingSeen = false,
  className = ""
}) => {
  const { t } = useLanguage();

  const isEventSeen = (event) => {
    return event.meta_data && event.meta_data.seen === true;
  };

  const handleSetSeen = () => {
    if (!isSettingSeen && onSetSeen) {
      onSetSeen(event.id);
    }
  };

  if (isEventSeen(event)) {
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 ${className}`}>
        {t('conversationActivities.seen')}
      </span>
    );
  }

  return (
    <button
      onClick={handleSetSeen}
      disabled={isSettingSeen}
      className={`inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {isSettingSeen ? (
        <>
          <svg className="animate-spin -ml-1 mr-2 h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {t('conversationActivities.setting')}
        </>
      ) : (
        t('conversationActivities.setSeen')
      )}
    </button>
  );
};

export default EventSeenStatus;
